import { CSSObject } from '@chakra-ui/react';
import carbonFiber from '@/assets/sterlingparker/images/backgrounds/carbonFiber.png';

export const FlexWrapper: CSSObject = {
  bg: 'transparent',
  border: '3px solid #CC952B',
  borderTop: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  boxShadow: '0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
};

export const FlexBannerWrapper: CSSObject = {
  px: '4',
  py: '2.5',
  m: 'auto',
  h: '44px',
  w: 'container.xl',
  bgImage: [null, `url(${carbonFiber})`],
};

export const FlexItemsWrapper: CSSObject = {
  mr: '0',
  columnGap: '1',
  '& > div:last-of-type': { mr: '0' },
};

export const LinkItem: CSSObject = {
  borderRadius: '5px',
  bg: 'beta.400',
  boxShadow:
    '0px 3px 10px 0px rgba(0, 0, 0, 0.25), 0px 1px 0px 0px rgba(255, 255, 255, 0.06) inset',
  w: '152px',
  gap: '3px',
  px: '4px',
  py: 0,
  pos: 'relative',
  contain: 'paint',

  '> *': { zIndex: 9 },

  _hover: {
    _after: { opacity: 0 },
  },

  _after: {
    content: `''`,
    pos: 'absolute',
    inset: 0,
    bg: 'var(--bc-gradient-grey, linear-gradient(180deg, #30363F 0%, #21252B 100%))',
    transition: 'all .2s ease-in-out',
  },

  '&&': {
    '.chakra-badge': {
      pos: 'static',
      borderRadius: '3px',
      padding: '3px 4px',
      color: 'var(--bc-white, #FFF)',
      textAlign: 'center',
      fontSize: '9px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 700,
      ml: 0,
      lineHeight: '17px',
    },
    '.chakra-badge.state-inprogress': {
      color: 'var(--chakra-black-alpha-800, rgba(0, 0, 0, 0.80))',
    },
  },
};

export const FlexDetails: CSSObject = {
  color: 'white',
  display: 'block',
  maxW: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: 0,
  flex: 1,
};

export const Icon: CSSObject = {
  color: 'white',
  ml: 0,
};

export const RaceNumber: CSSObject = {
  color: 'var(--bc-alpha-500, #FAB735)',
  textAlign: 'center',
  fontSize: '9px',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 700,

  borderRadius: '3px',
  background: 'var(--bc-beta-700, #1C1D21)',

  display: 'flex',
  width: '19px',
  height: '17px',
  padding: '3px 4px',
  justifyContent: 'center',
  alignItems: 'center',

  order: 4,
  mr: 0,
};

export const FlexButtonContainer: CSSObject = {
  bg: 'transparent',
  pos: 'relative',
  p: '0',
  pl: '1',
  gap: '0.5',
  mr: 0,
};

export const ButtonChevron: CSSObject = {
  display: 'flex',
  minW: '24px',
  width: '24px',
  height: '24px',
  padding: '0px 4px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '4px',
  borderRadius: '5px',
  background:
    'var(--bc-gradient-grey, linear-gradient(180deg, #30363F 0%, #21252B 100%))',
  boxShadow:
    '0px 3px 10px 0px rgba(0, 0, 0, 0.25), 0px 1px 0px 0px rgba(255, 255, 255, 0.06) inset',

  color: 'var(--bc-white, #FFF)',
  fontSize: '10px',
  fontStyle: 'normal',
  fontWeight: 900,
  letterSpacing: '0.4px',
  textTransform: 'uppercase',
};
